import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import './styles.scss'
import { getParamId } from '@utilities/mdHandler'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import { history } from '@services/History'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'
import Input from '../../../adminv2/common/Input'
import Marketing from '@services/Marketing'
import uuid from 'uuid/v4'
import { useDispatch } from 'react-redux'
import { showAlert } from '../alert/Alert.dux'
import Alert from '../../../adminv2/common/Alert'

const FeedUpdate = (props) => {
  const id = getParamId(props)
  const { t } = useTranslation()
  const titleHeader = id ? t('feedEditFeed') : t('feedCrateFeed')
  const dispatch = useDispatch()
  const editMode = id ? true : false
  const submitting = false
  const [usersGroups, setUsersGroups] = useState([])

  const initialFormValues = { id: id ?? uuid(), feedName: '', usersGroupsSelected: [] }
  const [formData, setFormData] = useState(initialFormValues)

  useEffect(() => {
    const updateEditValues = (values) => {
      const arrayUsersGroups = []
      const oldValues = {
        id: id,
        feedName: values.name,
      }

      if (values.user_group_list.length) {
        values.user_group_list.forEach((value) => {
          const item = {
            id: value.legacy_id,
            label: value.code,
            value: value.code,
          }
          arrayUsersGroups.push(item)
        })
      }

      oldValues.usersGroupsSelected = arrayUsersGroups
      setFormData(oldValues)
    }

    id &&
      Marketing.MFeed.index().then((res) => {
        let actualContent = res.data.find((element) => element.id === id)
        updateEditValues(actualContent.attributes)
      })

    Marketing.MUserGroups.index({ limit: 500 }).then((res) => {
      let userGroupsArray = []
      res.data.forEach((value) => {
        userGroupsArray.push({
          label: value.attributes.code,
          value: value.attributes.code,
          id: value.attributes.legacy_id,
          feedID: value.id,
        })
      })
      setUsersGroups(userGroupsArray)
    })
  }, [])

  const selectAction = (value, action) => {
    if (action.action === 'select-option') checkGroup(value)
    if (action.action === 'remove-value') checkGroup(value)
  }

  const checkGroup = (groups) => {
    setFormData({ ...formData, usersGroupsSelected: groups })
  }

  const failureAlertOpening = (text) => {
    dispatch(
      showAlert({
        text: text ?? t('generalUpdatingErrorMEssage'),
        important: !text ? 'Oh snap!' : '',
        type: 'danger',
      })
    )
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    const updateGroup = (groups, NewID) => {
      const idFeed = id ?? NewID
      const relationships = []

      groups.forEach((group) => {
        const relationshipFormated = {
          id: uuid(),
          feed_id: idFeed,
          usergroup_id: group.id,
        }
        relationships.push(relationshipFormated)
      })

      if (id) {
        Marketing.MrelationshipsFeed.delete(idFeed).then((res) => {
          if (res.status === 204) {
            Marketing.Mrelationships.store(relationships).then((res) =>
              res.status === 201 ? history.push('/content') : failureAlertOpening()
            )
          } else {
            failureAlertOpening()
          }
        })
      } else {
        Marketing.Mrelationships.store(relationships).then((res) =>
          res.status === 201 ? history.push('/content') : failureAlertOpening()
        )
      }
    }

    let copyFormData = structuredClone(formData)
    const { usersGroupsSelected } = copyFormData
    const marketingData = { id: copyFormData.id, name: copyFormData.feedName }

    //Si estamos editando hacemos un put y si no un post
    editMode
      ? Marketing.MFeed.update(id, marketingData).then((res) => {
          if (res.status === 204) {
            updateGroup(usersGroupsSelected)
          } else {
            failureAlertOpening()
          }
        })
      : Marketing.MFeed.store(marketingData).then((res) => {
          if (res.status === 201) {
            updateGroup(usersGroupsSelected, marketingData.id)
          } else {
            failureAlertOpening()
          }
        })
  }

  return (
    <div className="content-update">
      <DashboardHeader title={titleHeader} total={null}>
        <Link className="btn btn-primary" to={`/content`}>
          {t('back')}
        </Link>
      </DashboardHeader>

      <Alert timeOut={3000} />

      <form className="integration-form" onSubmit={handleSubmit} id="company-form">
        <div className="container-fluid main-content">
          <div className="form-crud-feeds well">
            <section className="conf-content">
              <header className="header-content">
                <div className="header-content-titleContent">
                  {' '}
                  <h2>{t('feedConfigFeed')}</h2>{' '}
                </div>
              </header>
            </section>

            <section className="detail-content">
              <div className="complete-content">
                <Input
                  className="form-control"
                  id="feedName"
                  name="feedName"
                  label={`${t('feedNameFeed')}*`}
                  value={formData.feedName}
                  required
                  onChange={(value) => setFormData({ ...formData, feedName: value })}
                  displayRequiredMark={false}
                  type="text"
                />
              </div>

              <label>{t('feedUserGroups')}</label>

              <Select
                name="usersGroupsSelected"
                value={formData.usersGroupsSelected}
                isMulti
                options={usersGroups}
                onChange={selectAction}
              />
            </section>
          </div>

          <div className="form-crud-feeds">
            <div className="button-content">
              <button type="submit" className="btn btn-primary save-button" disabled={submitting}>
                {t('save')}
              </button>
              <button
                type="button"
                className="btn btn-outline-primary cancel-button"
                disabled={submitting}
                onClick={() => history.push('/content')}
              >
                {t('cancel')}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}
export default FeedUpdate
